export default "__VITE_ASSET__SBWdqpaX__"